import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {ModelGroupEditComponent} from '../../components/DomainDataEdit/ModelGroupEdit.component';

//base
import { BaseDomainDataGridComponent }         from '../../baseclasses/BaseDomainDataGrid';

@Component({
  selector: 'my-modelgroup-grid',
  templateUrl: './ModelGroupGrid.component.html'
})
export class ModelGroupGridComponent extends BaseDomainDataGridComponent {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(ModelGroupEditComponent) recordEditComponent: ModelGroupEditComponent;

    userInfo: ent.UserInfo;
    records: ent.ModelGroup[];
    selectedRecords: ent.ModelGroup[] = [];
    editedRecord: ent.ModelGroup;
    modelGroupFilter: filters.ModelGroupFilter;

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService,
         private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        this.modelGroupFilter = {IncludeInactive: true};
        this.editedRecord = new ent.ModelGroup();
        this.recordEditComponent.equipmentTypeDropdown.load();
        this.recordEditComponent.sectionDropdown.load();
        this.onSearchClick(null);
    }

    onSearchClick(event: any){
        this.domainDataService.getModelGroups(this.modelGroupFilter).subscribe(x=>{this.records = x});
    }

    onAddClick(event: any){
        this.editedRecord = new ent.ModelGroup();
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, modelGroup: ent.ModelGroup){
        this.editedRecord = modelGroup;
        this.recordEditComponent.equipmentTypeDropdown.value = modelGroup.EquipmentTypeID;
        this.recordEditComponent.sectionDropdown.value = modelGroup.SectionID;
        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveModelGroupRequest = {ModelGroup: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.domainDataService.saveModelGroup(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }
}